import { pickupDateByClientToReport } from '../../../../../core/models/dashboard/data-utilization-dad.model';

export const pickupDateByClient = {
    searchText: '',
    addText: '',
    export: true,
    exportFile: 'Fecha_de_recojo_por_parte_del_Cliente.xlsx',
    expandable: true,
    filter: false,
    paginator: true,
    filterDefault: '',
    disabled: false,
    partialField: '',
    columns: [
      {
        title: 'ID.',
        name: 'id',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center w130',
        value: (element: pickupDateByClientToReport) => element.id
      },
      {
        title: 'Compañía',
        name: 'companyCode',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: pickupDateByClientToReport) => element.companyCode
      },
      {
        title: 'Código de tipo de entrega ',
        name: 'deliveryTypeCode',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: pickupDateByClientToReport) => element.deliveryTypeCode
      },
      {
        title: 'Tipo de origen',
        name: 'originType',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: pickupDateByClientToReport) => element.originType
      },
      {
        title: 'ID. de estado',
        name: 'stateId',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: pickupDateByClientToReport) => element.stateId
      },
      {
        title: 'Tipo de entrega',
        name: 'deliveryTypeName',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: pickupDateByClientToReport) => element.deliveryTypeName
      },
      {
        title: 'Canal',
        name: 'channel',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: pickupDateByClientToReport) => element.channel
      },
      {
        title: 'Retraso en la retirada',
        name: 'storeWithdrawDelayDescription',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: pickupDateByClientToReport) => element.storeWithdrawDelayDescription
      },
      {
        title: 'Total',
        name: 'total',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: pickupDateByClientToReport) => element.total
      }
    ],
    subTable: {}
  };
